import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-reset-password-confirmation-screen',
  templateUrl: './reset-password-confirmation-screen.component.html',
  styleUrls: ['./reset-password-confirmation-screen.component.scss'],
})
export class ResetPasswordConfirmationScreenComponent {}
